import FlexCanvas from "./FlexCanvas.mjs";

const block_size = 80;
const rows = 5;
const columns = 5;
const margin = 2;
const padding = 24;

const movable_matrix = [
	[1,5],
	[0,2,6],
	[1,3,7],
	[2,4,8],
	[3,9],
	[0,6,10],
	[1,5,7,11],
	[2,6,8,12],
	[3,7,9,13],
	[4,8,14],
	[5,11,15],
	[6,10,12,16],
	[7,11,13,17],
	[8,12,14,18],
	[9,13,19],
	[10,16,20],
	[11,15,17,21],
	[12,16,18,22],
	[13,17,19,23],
	[14,18,24],
	[15,21],
	[16,20,22],
	[17,21,23],
	[18,22,24],
	[19,23]
]

function format_time(seconds) {
    var sec_num = parseInt(seconds, 10); // don't forget the second param
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    return hours + ':' + minutes + ':' + seconds;
}

class PhotoPuzzle {
	constructor(el, image_url) {
		this.ready = false;
		this.width = (block_size * columns) + (margin * (columns -1)) + (padding * 2);
		this.height = (block_size * rows) + (margin * (rows -1)) + (padding * 2);
		this.el = el;
		this.el.style.setProperty('--width', this.width + 'px');
		this.el.style.setProperty('--height', this.height + 'px');
		this.el.style.setProperty('--block-size', block_size + 'px');
		this.el.style.setProperty('--image-url', 'url(' + image_url +')');
		this.el.classList.add('ux-photo-puzzle');
		this.timer = null;
		this.handlers = {};

		let sb = [];

		this.state = [];

		for(let i=0;i<=(rows * columns) -1;i++) {
			this.state.push(i);
			sb.push('<span data-id="' + i + '" class="ux-block"></span>');
		}

		sb.push('<div class="ux-preview"></div>');
		sb.push('<div class="ux-overlay"></div>');

		this.el.innerHTML = sb.join('');

		this.el.addEventListener('click', (evt) => {
			if (!this.ready) return;

			if (evt.target.nodeName === 'SPAN') {
				if (evt.target.dataset['movable'] == 'true') {
					this.move(evt.target);
				}
			}
		})

		FlexCanvas(this.el, this.width, this.height);
		this.draw_board();
	}

	start() {
		this.count_down(5).then(() => {
			if (this.handlers['countdown-end'] && (typeof this.handlers['countdown-end'] === 'function')) {
				this.handlers['countdown-end']();	
			}

			this.shuffle();
			this.hide_preview();
			this.ready = true;

			let d = new Date();
			this.start_time = d.getTime();
			this.move_count = 0;

			if (this.handlers['start'] && (typeof this.handlers['start'] === 'function')) {
				this.handlers['start']();	
			}
		})
	}

	hide_preview() {
		this.el.querySelector('.ux-preview').classList.remove('photo-puzzle-fade-in');
		this.el.querySelector('.ux-preview').classList.add('photo-puzzle-fade-out');
	}

	show_preview() {
		this.el.querySelector('.ux-preview').classList.remove('photo-puzzle-fade-out');
		this.el.querySelector('.ux-preview').classList.add('photo-puzzle-fade-in');
	}

	show_summary(elapsed_time, move_count) {
		let el = document.createElement('div');

		console.log(elapsed_time, move_count);

		el.classList.add('ux-summary');
		el.classList.add('photo-puzzle-fade-in');
		el.innerHTML = '<span class="ux-key">Elapsed Time</span> : ' +  format_time(elapsed_time) + ', ' + move_count + ' moves';
		this.el.closest('.flex-canvas').after(el);
	}

	is_win() {
		let arr = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24];
		
		return this.state.every((v,i) => {
			return v === arr[i];
		})	
	}

	shuffle(iteration = 600) {
		for (let i=1;i<=iteration;i++) {
			let pos = this.state.indexOf(0);
			let movables = movable_matrix[pos];
			let x = movables[Math.round(Math.random() * (movables.length - 1))];

			this.state[pos] = this.state[x];
			this.state[x] = 0; 
		}

		this.draw_board();
	}

	get_row_and_column(idx) {
		let row, col;

		if ([0,1,2,3,4].includes(idx)) {
			row = 0;
		} else if ([5,6,7,8,9].includes(idx)) {
			row = 1;			
		} else if([10,11,12,13,14].includes(idx)) {
			row = 2;			
		} else if([15,16,17,18,19].includes(idx)) {
			row = 3;			
		} else {
			row = 4;
		}

		if ([0,5,10,15,20].includes(idx)) {
			col = 0;
		} else if ([1,6,11,16,21].includes(idx)) {
			col = 1;
		} else if ([2,7,12,17,22].includes(idx)) {
			col = 2;
		} else if ([3,8,13,18,23].includes(idx)) {
			col = 3;
		} else {
			col = 4;
		}

		return {row: row, col: col}
	}

	draw_board() {
		let pos = 0;
		let movables = movable_matrix[this.state.indexOf(0)];
		
		this.state.forEach(id => {
			let {row, col} = this.get_row_and_column(pos);
			let el = this.el.querySelector('[data-id="' + id + '"]');

			el.style.left = (col * block_size) + (col * margin) + padding + 'px';
			el.style.top = (row * block_size) + (row * margin) + padding + 'px';
			el.setAttribute('data-pos', pos);

			if (movables.includes(pos)) {
				el.setAttribute('data-movable', 'true');
			} else {
				el.removeAttribute('data-movable');				
			}

			pos = pos + 1;
		})
	}

	move(el) {
		let x = this.state.indexOf(0);
		let y = parseInt(el.dataset['pos']);

		this.state[x] = parseInt(el.dataset['id']);
		this.state[y] = 0;
		this.move_count = this.move_count + 1;

		this.draw_board();

		if (this.is_win()) {
			let d = new Date();
			
			this.end_time = d.getTime();
			this.elapsed_time = Math.round((this.end_time - this.start_time) / 1000);

			setTimeout(() => {
				this.show_preview();

				setTimeout(() => {
					this.show_summary(this.elapsed_time, this.move_count);
				}, 500);
			}, 500)

			if (this.handlers['win'] && (typeof this.handlers['win'] === 'function')) {				
				this.handlers['win']({
					elapsed_time: this.elapsed_time,
					move_count: this.move_count
				})
			}
		}
	}

	count_down(value) {
		let overlay = this.el.querySelector('.ux-overlay');

		return new Promise(resolve => {
			let do_count_down = (value) => {
				if (value <= 0) {
					if (this.timer) {
						clearTimeout(this.timer);

						setTimeout(() => {
							overlay.classList.remove('photo-puzzle-fade-in');
							overlay.classList.add('photo-puzzle-fade-out');
							return resolve(true);
						}, 1000)
					}
				} else {
					this.timer = setTimeout(() => {
						overlay.innerText = value;
						value = value - 1;
						do_count_down(value);
					}, 1000)
				}			
			}

			overlay.classList.remove('photo-puzzle-fade-out');
			overlay.classList.add('photo-puzzle-fade-in');

			if (this.handlers['countdown-start'] && (typeof this.handlers['countdown-start'] === 'function')) {
				this.handlers['countdown-start']();	
			}

			do_count_down(value);			
		})
	}

	on(event, handler) {
		this.handlers[event] = handler;
	}
}

export default (el, image_url) => {
	return new PhotoPuzzle(el, image_url);
}